import { makeStyles } from 'makeStyles';
import { LIST_HOVER, LIST_SELECTED, TEXT_MAIN } from 'theme/colors';
import css from 'theme/themeV2';

export const useStyles = makeStyles()((theme) => ({
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  headerLinkIcon: {
    height: 22,
    paddingTop: 5,
    width: 22,
  },
  linkedTournamentsCount: {
    height: 20,
  },
  headerSettingsIcon: {
    height: 24,
    paddingTop: 5,
    width: 24,
  },
  breadcrumb: {
    display: 'flex',
    fontSize: 16,
    marginBottom: '1em',
  },
  headerRoot: {
    position: 'relative',
  },
  headerPaper: {
    boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.04)',
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
  },
  headerRootPaddingTop: {
    paddingTop: theme.spacing(2.5),
  },
  chooseTournament: {
    '& h2': {
      lineHeight: 1.3,
    },
    '&:hover': {
      textDecoration: 'underline',
      '& $chooseTournamentIcon': {
        backgroundColor: theme.palette.grey[200],
      },
    },
  },
  chooseTournamentActive: {
    '& $chooseTournamentIcon': {
      transform: 'scaleY(-1)',
    },
  },
  chooseTournamentIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: theme.spacing(0.5),
    borderRadius: 4,
    color: TEXT_MAIN,
    width: 26,
    height: 26,
  },
  root: {
    flexGrow: 1,
    width: '100%',
    padding: theme.spacing(1),
  },
  pageWrapper: {
    width: '100%',
    padding: `${theme.spacing(3)} 0`,
  },
  tabPanel: {
    padding: `${theme.spacing(3)} 0`,
  },
  menuRightSubWrapper: {
    alignSelf: 'center',
    '& > div': {
      height: '100%',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  menuRight: {
    height: '100%',
    padding: '0 10px 0 0',
  },
  userMenu: {
    alignSelf: 'center',
    marginLeft: theme.spacing(2.5),
    '&:hover': {
      cursor: 'pointer',
    },
  },
  menuItemPaddingRight: {
    paddingRight: '10px',
  },
  menuImage: {
    margin: 'auto',
    height: 'auto',
    width: 'auto',
    maxHeight: '40px',
    maxWidth: '150px',
  },
  menuButton: {
    position: 'absolute',
    top: '24px',
    right: '10px',
  },
  menuButtonSm: {
    position: 'absolute',
    top: '5px',
    right: '10px',
  },
  logoDivider: {
    alignSelf: 'center!important',
    height: `50px!important`,
    margin: '0 10px!important',
  },
  tournamentName: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  button: {
    margin: theme.spacing(1),
  },
  form: {
    margin: 'dense',
  },
  tournamentNameWrapper: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  logoAndButtonWrapper: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: theme.zIndex.appBar,
  },
  tournamentLoader: {
    height: '100vh',
  },
  menuPaper: {
    border: `solid 1px ${theme.palette.grey['200']}`,
    boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
  },
  menuList: {
    padding: '12px 0 12px 0',
    '& .Mui-selected': {
      backgroundColor: `${LIST_SELECTED}`,
      '&:hover': {
        backgroundColor: `${LIST_HOVER}`,
      },
    },
    '& .MuiListItem-button': {
      padding: '6px 18px',
      fontSize: 15,
      '&:hover': {
        backgroundColor: `${LIST_HOVER}`,
      },
    },
  },
  tooltip: {
    padding: '4px 8px',
    borderRadius: 4,
    backgroundColor: '#2a3041',
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 'normal',
    textAlign: 'left',
    color: 'white',
  },
  [theme.breakpoints.down('md')]: {
    headerRootPaddingTop: {
      flexDirection: 'column',
    },
    logoAndButtonWrapper: {
      transform: 'none',
      position: 'relative',
    },
    menuImage: {
      margin: 'auto',
      height: 'auto',
      width: 'auto',
      maxHeight: '40px',
      maxWidth: '120px',
    },
  } as const,
}));

export const containerStyles = css({
  overflow: 'hidden',
  display: 'flex',
  flexWrap: 'nowrap',
});

export const mainContentStyles = css({
  overflow: 'auto',
  height: `calc(100vh - 56px - $$headerHeight)`,
  flexGrow: 1,
  marginLeft: '1.5rem',
});

export const navBarContainerStyles = css({
  width: 'inherit',
});

export const navBarStyles = css({
  '@sm': {
    width: 240,
    minWidth: 'unset',
  },
});

export const settingsItemStyles = css({
  padding: `0.40625rem 1.125rem`,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  color: '$coreGreys100main',
  fontSize: '$medium',
  lineHeight: 1.5,
  textDecoration: 'none',
});

export const tabContentStyles = css({
  minHeight: `calc(100vh - 116px - $$headerHeight)`,
  marginRight: '1.5rem',
});
